export const environment = {
  production: true,
  appUrl: (window as any).manageAppUrl,
  apiUri: (window as any).apiUrl,
  apiHostUrl: (window as any).apiHostUrl,
  snapchatStandardAppUrl: (window as any).snapchatStandardAppUrl,
  snapchatAutomatedAppUrl: (window as any).snapchatAutomatedAppUrl,
};
